import { render, staticRenderFns } from "./BaseUploadFile.vue?vue&type=template&id=57cfff90&scoped=true&"
import script from "./BaseUploadFile.vue?vue&type=script&lang=js&"
export * from "./BaseUploadFile.vue?vue&type=script&lang=js&"
import style0 from "./BaseUploadFile.vue?vue&type=style&index=0&id=57cfff90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cfff90",
  null
  
)

export default component.exports